import React, { useState, useEffect, useCallback } from 'react';
import uuid from 'uuid-random';

import style from './index.scss';

export default ({
    min,
    max,
    step = 0,
    defaultValue,
    colorsMap = {},
    title = '',
    labels = [],
    className = '',
    onChange
}) => {
    const [color, setColor] = useState(colorsMap[defaultValue]);
    const [isFocused, setIsFocused] = useState(false);
    const [value, setValue] = useState(defaultValue);

    const handleChange = useCallback((event) => {
        const { target: { value: eventValue } } = event;

        setColor(colorsMap[eventValue] || '');
        setValue(eventValue);
        onChange(event);

    }, [colorsMap, onChange]);

    useEffect(() => {
        if (!defaultValue) {
            setColor('');
            setValue(0);
        }
    }, [defaultValue]);

    const onKeyDown = useCallback((event) => {
        const { key } = event;
        const updateRange = (calculatedValue) => {
            setValue(calculatedValue);
            setColor(colorsMap[calculatedValue] || '');
            onChange({
                ...event,
                target: {
                    ...event.target,
                    value: calculatedValue
                }
            });
        };

        if (['ArrowRight', 'ArrowUp'].includes(key) && value < max) {
            event.preventDefault();

            updateRange(value + step);
        }

        if (['ArrowLeft', 'ArrowDown'].includes(key) && value > min) {
            event.preventDefault();

            updateRange(value - step);
        }
    }, [colorsMap, onChange, max, min, step, value]);

    const onKeyUp = (event) => {
        const { key } = event;

        if (key === 'Tab') {
            setIsFocused(true);
        }
    };

    const onBlur = useCallback(() => setIsFocused(false), []);

    return (
        <div className={`${style.container} ${className}`}>
            <input
                min={min}
                max={max}
                step={step}
                type="range"
                value={value}
                onBlur={onBlur}
                onKeyUp={onKeyUp}
                onKeyDown={onKeyDown}
                aria-valuetext={title}
                onChange={handleChange}
                aria-labelledby="rangeTitle"
                className={`${style.range} ${color} ${isFocused ? style.focused : ''}`}
            />

            {title && <div className={style.datalist}>
               <span id="rangeTitle" key={uuid()}>{title}</span>
            </div>}

            {labels.length > 0 && (
                <div className={style.datalist}>
                    {
                        labels.map(label => <span key={uuid()}>{label}</span>)
                    }
                </div>
            )}
        </div>
    );
};
